import React from "react";
import { Swiper } from "swiper/react";
import { HashNavigation, Navigation, Pagination } from "swiper";

const SwiperComp = ({ children }) => {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      hashNavigation={{
        watchState: true,
      }}
      pagination={{
        clickable: true,
      }}
      breakpoints={{
        620: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        940: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1256: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      }}
      navigation={true}
      modules={[ Navigation, HashNavigation]}
      className="mySwiper"
    >
      {children}
    </Swiper>
  );
};

export default SwiperComp;
